const modalActions = {
    create: 'create',
    edit: 'edit'
};

export { modalActions };